// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

export function setDefaultSavedView(ydb: Database, viewId: string): void {
  ydb.mutate((db) => {
    db.defaultViewId = viewId;
  });
}
